import { render, staticRenderFns } from "./CustomTabEditor.vue?vue&type=template&id=411dd8d4&scoped=true&"
import script from "./CustomTabEditor.vue?vue&type=script&lang=js&"
export * from "./CustomTabEditor.vue?vue&type=script&lang=js&"
import style0 from "./CustomTabEditor.vue?vue&type=style&index=0&id=411dd8d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411dd8d4",
  null
  
)

export default component.exports